/*
 * component.selectfx
 * http://github.com/typesettin/component.selectfx
 *
 * Copyright (c) 2014 Typesettin. All rights reserved.
 */

'use strict';

module.exports = require('./lib/component.selectfx');
